var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"headerBox"},[_vm._v("知识库管理系统")]),_c('div',{staticClass:"header-right"},[_c('el-button',{staticClass:"cancelButton",on:{"click":_vm.quit}},[_vm._v("退出")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }